module.exports = __webpack_public_path__ + "footimgs.png?8a39fade3ea32dd29a81527f4ee62b40";